/**
 * Created by Ivan on 06.02.2026
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TREASURE_SEARCH_TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.TreasureSearchWindow = {
    delay: 11.5,

    playHint: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -160, anchor: false }
        },
        height: 250
    },

    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    timer: {
        width: 250,
        positions: [{
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -86 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -86 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -86 }
        }]
    }
};
